import { gettext } from '@eb/i18n-ebspa';

import { ORGANIZER_POPULAR_CATEGORIES } from 'consumer-utils/constants/categories';

import {
    // bucket keys
    FOLLOWED_PROFILES,
    ORGANIZERS_TO_FOLLOW,
    PRIMARY_BUCKET,
    SECONDARY_BUCKET,
    FIVE_TO_FOLLOW_IN_MUSIC,
    BEST_OF_CITY_EVENTS,
    LIKED_EVENTS,
    FIVE_TO_FOLLOW_IN_FOOD_AND_DRINK,
    RECOMMENDED_EVENTS,

    // icons
    HEART_ICON,
    USER_ICON,
    FRIENDS_ICON,

    // tlds
    TLD_UNITED_STATES,
    TLD_UNITED_KINGDOM,
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_IRELAND,

    // languages
    LANGUAGE_AUSTRALIA,
    LANGUAGE_CANADA,
    LANGUAGE_UNITED_KINGDOM,
    LANGUAGE_UNITED_STATES,
    LANGUAGE_IRELAND,

    // collections
    EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
    MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
    EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
    ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
    FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
    FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
    EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
    CONNECT_THROUGH_ONLINE_EVENTS,
    QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
    ENTERTAIMENT_TONIGHT,
    BLACK_HISTORY_AND_BEYOND,
    BEST_UK_AND_IRELAND_EVENTS_URL,
    ONLINE_THANKSGIVING_COOKING,
} from './constants';
import { constants as destinationConstants } from '@eb/destination-utils';

import { GRID_TYPE } from '@eb/eds-media-card-content';

const {
    MUSIC_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    CHARITY_EVENTBRITE_CATEGORY,
    CURRENT_FUTURE,
    DATES_MAPPING,
    PRICE_MAPPING,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING,
} = destinationConstants;

export const ALL_TAB = 'all';
export const THIS_WEEKEND_TAB = 'this_weekend';
export const FREE_TAB = 'free';
export const FOR_YOU = 'for_you';
export const MUSIC_TAB = 'music';
export const FOOD_TAB = 'food';
export const CHARITY_TAB = 'charity';
export const SEASONAL_TAB = 'seasonal';
export const TODAY_TAB = 'today';

const MUSIC_TAB_NAME = EVENTBRITE_CATEGORY_MAPPING[MUSIC_EVENTBRITE_CATEGORY];
const MUSIC_TAB_NAME_LOWER =
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[MUSIC_EVENTBRITE_CATEGORY];

const FOOD_TAB_NAME =
    EVENTBRITE_CATEGORY_MAPPING[FOOD_AND_DRINK_EVENTBRITE_CATEGORY];
const FOOD_TAB_NAME_LOWER =
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[FOOD_AND_DRINK_EVENTBRITE_CATEGORY];

const CHARITY_TAB_NAME =
    EVENTBRITE_CATEGORY_MAPPING[CHARITY_EVENTBRITE_CATEGORY];
const CHARITY_TAB_NAME_LOWER =
    EVENTBRITE_CATEGORY_LOWERCASE_MAPPING[CHARITY_EVENTBRITE_CATEGORY];

export const FEED_TABS = [
    ALL_TAB,
    FOR_YOU,
    TODAY_TAB,
    THIS_WEEKEND_TAB,
    `${SEASONAL_TAB}${'_0'}`,
    `${SEASONAL_TAB}${'_1'}`,
    `${SEASONAL_TAB}${'_2'}`,
    `${SEASONAL_TAB}${'_3'}`,
    FREE_TAB,
    MUSIC_TAB,
    FOOD_TAB,
    CHARITY_TAB,
];

export const TABS_CONFIG = {
    [ALL_TAB]: {
        tabKeyLabel: 'All',
        name: gettext('All'),
        eventSearch: {
            dates: [CURRENT_FUTURE],
        },
        follow: ORGANIZER_POPULAR_CATEGORIES,
        hasFiveToFollow: true,
        collections: {
            [TLD_UNITED_STATES]: {
                [LANGUAGE_UNITED_STATES]: [
                    EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
                    MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
                    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
                    EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
                    ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
                    FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
                    FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
                    EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
                    QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
                    ENTERTAIMENT_TONIGHT,
                    ONLINE_THANKSGIVING_COOKING,
                ],
            },
            [TLD_CANADA]: {
                [LANGUAGE_CANADA]: [
                    EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE,
                    MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME,
                    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
                    EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME,
                    ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE,
                    FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED,
                    FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME,
                    EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS,
                    QA_TEST_MADE_FOR_NYC_FOOD_LOVERS,
                    ENTERTAIMENT_TONIGHT,
                ],
            },
            [TLD_UNITED_KINGDOM]: {
                [LANGUAGE_UNITED_KINGDOM]: [
                    BLACK_HISTORY_AND_BEYOND,
                    WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED,
                    BEST_UK_AND_IRELAND_EVENTS_URL,
                    ENTERTAIMENT_TONIGHT,
                ],
            },
            [TLD_IRELAND]: {
                [LANGUAGE_IRELAND]: [
                    BEST_UK_AND_IRELAND_EVENTS_URL,
                    ENTERTAIMENT_TONIGHT,
                ],
            },
            [TLD_AUSTRALIA]: {
                [LANGUAGE_AUSTRALIA]: [CONNECT_THROUGH_ONLINE_EVENTS],
            },
        },
        feedConfig: {
            [BEST_OF_CITY_EVENTS]: {
                order: 1,
                propsOverwrite: {
                    name: gettext("Editor's picks"),
                    subtitle: gettext(
                        'Discover <location>’s best experiences, hand-picked by our experts.',
                    ),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                ],
                overwrite: {
                    props: {
                        layout: {
                            desktop: {
                                events: {
                                    bucketClassNames:
                                        'premium-events-bucket__content eds-l-pad-bot-8',
                                    layout: {
                                        default: {
                                            containerClasses: [
                                                'feed__card-cell premium-card',
                                            ],
                                        },
                                    },
                                },
                            },
                            mobile: {
                                events: {
                                    bucketClassNames:
                                        'premium-events-bucket__content eds-l-pad-bot-8',
                                    layout: {
                                        default: {
                                            containerClasses: [
                                                'feed__card-cell premium-card',
                                            ],
                                        },
                                    },
                                    propsOverwrite: {
                                        default: {
                                            type: GRID_TYPE,
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
            },
            [PRIMARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('Events in <location>'),
                },
                shouldShowOnboardingCard: true,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [FIVE_TO_FOLLOW_IN_MUSIC]: {
                order: 4,
                orderAfter: [
                    PRIMARY_BUCKET,
                    BEST_OF_CITY_EVENTS,
                    ORGANIZERS_TO_FOLLOW,
                ],
                propsOverwrite: {
                    name: gettext('Five to follow in music'),
                },
                shouldShowOnboardingCard: false,
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 5,
                propsOverwrite: {
                    name: gettext('More events'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [FOR_YOU]: {
        tabKeyLabel: FOR_YOU,
        name: gettext('For you'),
        feedConfig: {
            [LIKED_EVENTS]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('My liked events'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                        },
                        config: {
                            title: gettext('Like your favorites events'),
                            iconType: HEART_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'Get better recomendations and see more events you´ll love',
                            ),
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                        },
                        config: {
                            title: gettext(
                                'Discover the best events, picked just for you',
                            ),
                            iconType: USER_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'Keep track of your liked events and see events from your favorite organizers when you log in',
                            ),
                            primaryText: gettext('Log In'),
                            primaryLink: '/login/?referrer=%2F',
                        },
                    },
                ],
            },
            [FOLLOWED_PROFILES]: {
                order: 1,
                propsOverwrite: {
                    name: gettext('From organizers you follow'),
                },
                shouldShowOnboardingCard: false,
                shouldShowEmptyState: true,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                        },
                        config: {
                            title: gettext('Follow your favorites organizers'),
                            iconType: FRIENDS_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'See their latest events here',
                            ),
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
            [RECOMMENDED_EVENTS]: {
                order: 0,
                propsOverwrite: {
                    name: gettext('Recommended events'),
                },
                shouldShowOnboardingCard: false,
                shouldShowEmptyState: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                        },
                        config: {
                            title: gettext('Recommended events'),
                            iconType: FRIENDS_ICON,
                            iconSize: 'medium',
                            description: gettext(
                                'See their latest events here',
                            ),
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
            // [ORGANIZERS_TO_FOLLOW]: {
            //     order: 3,
            //     propsOverwrite: {
            //         name: gettext('Organizers to follow'),
            //     },
            //     shouldShowOnboardingCard: false,
            //     layout: {
            //         desktop: {
            //             events: {
            //                 bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
            //             },
            //         },
            //         mobile: {
            //             events: {
            //                 bucketClassNames: 'organizers-bucket__content eds-l-pad-bot-8',
            //             },
            //         },
            //     },
            // },
        },
    },
    [THIS_WEEKEND_TAB]: {
        tabKeyLabel: 'ThisWeekend',
        name: DATES_MAPPING[THIS_WEEKEND_TAB],
        eventSearch: {
            dates: [CURRENT_FUTURE, 'this_weekend'],
        },
        follow: [],
        hasFiveToFollow: true,
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [FIVE_TO_FOLLOW_IN_MUSIC]: {
                order: 2,
                orderAfter: [PRIMARY_BUCKET],
                propsOverwrite: {
                    name: gettext('Five to follow in music'),
                },
                shouldShowOnboardingCard: false,
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More events this weekend'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [FREE_TAB]: {
        tabKeyLabel: 'Free',
        name: PRICE_MAPPING[FREE_TAB],
        eventSearch: {
            dates: [CURRENT_FUTURE],
            price: FREE_TAB,
        },
        follow: [],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('More free events'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [MUSIC_TAB]: {
        tabKeyLabel: 'Music',
        name: MUSIC_TAB_NAME,
        shouldShowOnboardingCard: false,
        eventSearch: {
            dates: [CURRENT_FUTURE],
            tags: MUSIC_EVENTBRITE_CATEGORY,
        },
        follow: [MUSIC_EVENTBRITE_CATEGORY],
        hasFiveToFollow: true,
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [FIVE_TO_FOLLOW_IN_MUSIC]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('Five to follow in music'),
                },
                shouldShowOnboardingCard: false,
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {
                        tabName: MUSIC_TAB_NAME_LOWER,
                    }),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [FOOD_TAB]: {
        tabKeyLabel: 'FoodAndDrink',
        name: FOOD_TAB_NAME,
        eventSearch: {
            dates: [CURRENT_FUTURE],
            tags: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
        },
        follow: [FOOD_AND_DRINK_EVENTBRITE_CATEGORY],
        hasFiveToFollow: true,
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [FIVE_TO_FOLLOW_IN_FOOD_AND_DRINK]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('Five to follow in Food and Drink'),
                },
                shouldShowOnboardingCard: false,
                layout: {
                    desktop: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                    mobile: {
                        events: {
                            bucketClassNames:
                                'five-to-follow-bucket__content eds-l-pad-bot-8',
                        },
                    },
                },
            },
            [SECONDARY_BUCKET]: {
                order: 3,
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {
                        tabName: FOOD_TAB_NAME_LOWER,
                    }),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [CHARITY_TAB]: {
        tabKeyLabel: 'Charity',
        name: CHARITY_TAB_NAME,
        eventSearch: {
            dates: [CURRENT_FUTURE],
            tags: CHARITY_EVENTBRITE_CATEGORY,
        },
        follow: [CHARITY_EVENTBRITE_CATEGORY],
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                orderAfter: [ORGANIZERS_TO_FOLLOW],
                propsOverwrite: {
                    name: gettext('More %(tabName)s events', {
                        tabName: CHARITY_TAB_NAME_LOWER,
                    }),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
    [TODAY_TAB]: {
        tabKeyLabel: 'Today',
        name: DATES_MAPPING[TODAY_TAB],
        eventSearch: {
            dates: [CURRENT_FUTURE, 'today'],
        },
        follow: [],
        hasFiveToFollow: false,
        feedConfig: {
            [PRIMARY_BUCKET]: {
                order: 1,
                propsOverwrite: {
                    name: '',
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: true,
                            useDefault: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: true,
                            isAuthenticated: false,
                            useDefault: true,
                        },
                    },
                ],
            },
            [SECONDARY_BUCKET]: {
                order: 2,
                propsOverwrite: {
                    name: gettext('More events today'),
                },
                shouldShowOnboardingCard: false,
                emptyState: [
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: true,
                        },
                    },
                    {
                        validation: {
                            shouldShowEmptyState: false,
                            isAuthenticated: false,
                        },
                    },
                ],
            },
        },
    },
};
